module.exports = __webpack_public_path__ + "static/media/banana.302a42fa.png";